module.exports = __webpack_public_path__ + "media/images/masks/avatar-group-hover-last-cc54d034df3912f69950d2fb274aa5358c031684f6bbca7fcf95785d0fd0b7e7.svg";